module.exports = __webpack_public_path__ + "static/media/wet-leaf-on-vine.745e5579.jpg";